import {StyleType} from '../../../../styles';
import {ColorsType} from '../../../../styles/Colors';

export type IndicatorColor = 'purple' | 'green' | 'red' | 'blue';
export type IndicatorSize = '28' | '16' | '14' | '10' | '8' | '5' | '4';
export type IndicatorType = 'quantity' | 'status';

export interface IndicatorProps {
  id?: string;
  className?: string;
  size: IndicatorSize;
  color: IndicatorColor;
  type: IndicatorType;
  quantity?: number;
  containerStyle?: any;
}

export const IndicatorBorderWidthySize: Record<string, number> = {
  '28': 2.63,
  '16': 1.5,
  '14': 1.31,
  '10': 0.94,
  '8': 0.75,
  '5': 0.47,
  '4': 0.38,
};

export const createBgColorMap = (Colors: ColorsType) => ({
  purple: Colors.primary700,
  red: Colors.alert300,
  green: Colors.success300,
  blue: Colors.info300,
});

export const fontMap = (fontStyles: StyleType) => ({
  '28': fontStyles['indicatorXLG'],
  '16': fontStyles['indicatorLG'],
  '14': fontStyles['indicatorMD'],
  '10': fontStyles['indicatorSM'],
  '8': fontStyles['indicatorXS'],
  '5': fontStyles['indicator2XS'],
  '4': fontStyles['indicator3XS'],
});
